module.exports = __webpack_public_path__ + "img/18.78bcd7f9.jpg";